import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 分页查询视频-图片-轨迹
export function dataPage(params) {
  const url = IhLogUrl + '/media/gps/union/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('数据中心', '分页查询视频-图片-轨迹', res)
    }
    return Promise.resolve(res.data)
  })
}
// 批量更新视频-图片-轨迹的类别
export function dataUpdate(params) {
  const url = IhLogUrl + '/media/gps/union/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('数据中心', '批量更新视频-图片-轨迹的类别', res)
    }
    return Promise.resolve(res.data)
  })
}

// 根据分组id查询具体可播放视频
export function unionFindByGroup(params) {
  const url = IhLogUrl + '/media/gps/union/find/group'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('数据中心', '根据分组id查询具体可播放视频', res)
    }
    return Promise.resolve(res.data)
  })
}
